import { queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { obtenerInvoiceDeSolicitud } from "../services/invoice-de-solicitud.api";

/**
 * Invoice (factura extranjera) de UNA solicitud · carga PEREZOSA: el panel se monta
 * solo al expandir la fila, así que la petición sale hasta entonces.
 */
export const invoiceDeSolicitudQueryOptions = (solicitudId: string) =>
  queryOptions({
    queryKey: qk.invoiceDeSolicitud(solicitudId),
    queryFn: () => obtenerInvoiceDeSolicitud(solicitudId),
    staleTime: 60_000,
  });

export function useInvoiceDeSolicitud(solicitudId: string) {
  return useQuery(invoiceDeSolicitudQueryOptions(solicitudId));
}
